import React, { useState } from "react";
import { adminAuthApi } from "../api/auth";
import { ApiError } from "../api/utils";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface AdminSignInProps {
  onSuccess: () => void;
  onError: (error: string) => void;
}

const AdminSignIn: React.FunctionComponent<AdminSignInProps> = ({
  onSuccess,
  onError,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await adminAuthApi.signIn(email, password);
      onSuccess();
    } catch (err: unknown) {
      if (err instanceof ApiError) {
        onError(err.message);
      } else {
        onError("An error occurred during sign in");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="admin-email">Email</Label>
        <Input
          id="admin-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="admin-password">Password</Label>
        <Input
          id="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <Button type="submit" disabled={loading} className="w-full">
        {loading ? "Signing in..." : "Sign In"}
      </Button>
    </form>
  );
};

export default AdminSignIn;
